import { type Card, type Grade, type RecordLogItem, Grades } from 'ts-fsrs';
import { scheduler } from './fsrs';

export function rateCard(card: Card, rating: Grade, now: Date): RecordLogItem {
  return scheduler.next(card, now, rating);
}

export interface IntervalPreview {
  rating: Grade;
  due: Date;
  days: number;
}

export function previewIntervals(card: Card, now: Date): IntervalPreview[] {
  const preview = scheduler.repeat(card, now);

  return Grades.map((rating) => {
    const { card: scheduled } = preview[rating];
    const days = Math.round(
      (scheduled.due.getTime() - now.getTime()) / 86400000,
    );
    return { rating, due: scheduled.due, days };
  });
}
